<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="100px"
    class="material-img"
  >
    <el-form-item
      label="媒体文件"
      prop="imgUrl"
    >
      <div class="upload-box">
        <el-upload
          v-if="!selfFileName"
          class="avatar-uploader"
          action="''"
          :show-file-list="false"
          :http-request="uploadUrlHandle"
          :before-upload="beforeAvatarUpload"
          v-loading="uploadLoading"
        >
          <el-button
            type="primary"
            size="small"
            v-if="!form.voiceUrl"
          >选择文件</el-button>
        </el-upload>
        <div
          v-if="form.voiceUrl || selfFileName"
          class="self-select">
          <div class="self-left">
            <icon-svg
              :icon-class="iconClass"
              class="icon-self-el"
            ></icon-svg>
            <span class="text">{{selfFileName}}</span>
          </div>
          <span
            @click.stop="removeHandle"
            class="self-right">
              <i class="el-icon-close"></i>
            </span>
        </div>
      </div>
    </el-form-item>
    <el-form-item
      label="媒体类型"
      prop="mediaType"
    >
      <el-select
        v-model="fileType"
        placeholder="媒体类型"
        style="width:100%"
        disabled
      >
        <el-option
          label="图片（2M以内，支持PNG\JPEG\JPG\GIF）"
          value="image"
        ></el-option>
        <el-option
          label="视频（10M以内，只支持MP4）"
          value="video"
        ></el-option>
        <el-option
          label="语音（2M、60s以内，支持AMR\MP3）"
          value="voice"
        ></el-option>
        <el-option
          label="缩略图（64K以内JPG）"
          value="thumb"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="素材名称"
      prop="fileName"
    >
      <el-input
        v-model="form.fileName"
        placeholder="为便于管理建议按用途分类+素材内容命名"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import {limitVoiceSizeFormat, limitVideoSizeFormat} from "../../../../utils/common";
let origin = {
  voiceUrl: '',
  fileName: '',
}
//音频: 语音和视频
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "audioForm",
  components: {
  },
  props: {
    fileType:{
      type: String,
      default: 'voice'
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        voiceUrl: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        mediaType: [
          // { required:true, message: '请选择', trigger: 'change' },
        ],
        fileName: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
      },
      uploadLoading: false,
      dialogImageUrl: '',
      selfFileName: '',
      file: '',//文件
    }
  },
  watch:{
  },
  computed: {
    iconClass(){
      return this.fileType == 'voice' ? 'yuyin': 'shipin';
    }
  },
  mixins: [formLabalPosition],
  created(){
  },
  methods: {
    removeHandle(){
      this.form.voiceUrl = '';
      this.selfFileName = '';
    },
    // 上传的限制
    beforeAvatarUpload(file){
      //加上了语音和视频,语音和视频文件比较大
      if(this.fileType == 'voice'){
        return limitVoiceSizeFormat(file,this);
      }else {
        return limitVideoSizeFormat(file,this);
      }
    },
    uploadUrlHandle(item){
      this.file = item.file;
      this.selfFileName = item.file.name;
      this.form.fileName = item.file.name.substring(0, item.file.name.lastIndexOf('.'));
      let mediaType = item.file.type.substring(0, item.file.type.lastIndexOf('/'));

    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
      this.selfFileName = '';
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo
    handlePictureCardPreview(){
      this.dialogImageUrl = this.form.voiceUrl;
    },
    handleRemove(){
      this.form.voiceUrl = '';
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form,this.file,this.fileType);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.material-img {
  .upload-box {
    width: 100%;
  }
  .avatar-uploader {

  }
  .self-select {
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border: 2px solid $themeColor;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-self-el,
    .text,
    .el-icon-close {
      color: $themeColor;
    }
    .icon-self-el {
      margin-right: 5px;
    }
    .self-right {
      cursor: pointer;
    }
    .el-icon-close {
      font-size: 18px;
    }
  }
}
</style>
